<template>
    <ion-page>
        <back-button :backBtn="isMobile" backText="Back" v-if="!isNative" class="back-btn" />
        <ion-content v-if="!loading">
            <div class="block-container" style="background: var(--ion-color-background); display: flex; flex-direction: column">
                <div v-if="currentPage">
                    <div v-html="currentPage.content" ref="pageRef" />
                </div>
            </div>
            <Footer />
        </ion-content>
        <ion-spinner v-if="loading" name="lines-small" class="full-height full-width" />
    </ion-page>
</template>

<script lang="ts">
import { defineComponent, computed, watch, ref, onMounted } from 'vue';
import { IonPage, IonContent, IonSpinner, onIonViewWillEnter } from '@ionic/vue';
import staticPageRoutes from '@/router/staticPageRoutes';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import updateMeta from '@/services/pageService';
import Footer from '@/components/layout/Footer.vue';
import useVueLinks from '@/composables/useVueLinks';
import { useUrlQueryParser } from '@/composables/useUrlQueryParser';
import backButton from '@/components/backButton.vue';

export default defineComponent({
    props: {},
    components: { IonPage, Footer, IonContent, IonSpinner, backButton },
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const loading = ref(true);
        const pageRef = ref();
        const isMobile = computed(() => store.getters.isMobile);
        const isNative = computed(() => store.getters.isNative);

        onMounted(() => setTimeout(() => useVueLinks(pageRef.value, router), 2000));

        const { handleQueries } = useUrlQueryParser();
        onIonViewWillEnter(() => {
            handleQueries();
        });

        const currentPage = computed(() => {
            return store.getters.getStaticPage(route.path);
        });

        watch(currentPage, (page) => {
            if (page) {
                updateMeta({ title: page.metaTitle, description: page.metaDescription, keywords: page.metaKeywords });
                loading.value = false;
                setTimeout(() => useVueLinks(pageRef.value, router), 2000);
            }
        });
        return { staticPageRoutes, currentPage, loading, pageRef, isNative, isMobile, store };
    },
});
</script>

<style>
ion-content {
    background: var(--ion-color-background);
}

ion-spinner {
    max-width: 200px;
    margin-left: auto;
    margin-right: auto;
}
.full-block {
    background-color: var(--ion-color-primary);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: xx-large;
    width: 100%;
    color: white;
}

.full-block > * {
    color: white;
}

.short-block {
    width: 75%;
    margin-left: auto;
    margin-right: auto;
    background-color: white;
    padding: 30px;
}

@media screen and (max-width: 960px) {
    .short-block {
        width: 100% !important;
    }
}
</style>
